<template>
  <div :class="'container-' + uniqueKey" class="d-input-wrapper">
    <span class="p-float-label" :style="`width: ${width}`">
      <PInput
        :id="'InputText'+uniqueKey"
        aria-describedby="text-error"
        :class="{ 'cursor-stop': maxlength && value && value.length >= maxlength, 'p-invalid': errorMessage }"
        :type="type"
        :model-value="value"
        @input="handleEmit"
        :required="required"
        :disabled="disabled"
        :maxlength="maxlength"
        :readonly="readOnly"
        :placeholder="placeholder"
      />
      <label :for="'InputText'+uniqueKey">{{ label }}</label>
    </span>
      <svg v-if="isLoading" class="wizard-spinner animate-spin h-4 w-4 text-neutral-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" role="status">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 12 0 12 0v4a8 8 0 010 16v4c-6.627 0-12-5.373-12-12z"/>
      </svg>
      <span class="md-error vp-pl-2 ">{{ errMsg }}</span>
  </div>
</template>

<script>
// import "vue-material/dist/theme/default.css";
import { randomStringMixin } from "@/utils/mixins/generateRandomStringMixin";
export default {
  data() {
    return {
      uniqueKey: this.randomString(10),
      container: null,
    };
  },
  mixins: [randomStringMixin],
  props: {
    value: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "text",
    },
    required: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: Boolean,
      default: false,
    },
    passwordIcon: {
      type: Boolean,
      default: true,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    invalid: {
      type: Boolean,
      default: false,
    },
    errMsg: {
      type: String,
      default: "",
    },
    maxlength: {
      type: String,
      default: "",
    },
    /* ------ Placeholder props ------ */
    placeholder: {
      type: String,
      default: "",
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    // placeholderFontSize: {
    //   type: String,
    //   default: "16px",
    // },
    // placeholderFoneWeight: {
    //   type: String,
    //   default: "400",
    // },
    // placeholderFontColor: {
    //   type: String,
    //   default: "#606060de",
    // },

    /* ------ Container props ------ */
    width: {
      type: String,
      default: "422",
    },
    height: {
      type: String,
      default: "40px",
    },
    backgroundColor: {
      type: String,
      default: "#f2f2f2",
    },

    /* ------ Input props ------ */
    fontSize: {
      type: String,
      default: "16px",
    },
    fontWeight: {
      type: String,
      default: "700",
    },
    fontColor: {
      type: String,
      default: "#000000de",
    },

    /* ------ Label props ------ */
    label: {
      type: String,
      default: "",
    },
    labelFontSize: {
      type: String,
      default: "12px",
    },
    labelFontWeight: {
      type: String,
      default: "700",
    },
    labelColor: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    //Selectors
    this.container = document.querySelector(
      `.container-${this.uniqueKey} .md-theme-default`
    );
    // const label = document.querySelector(`.container-${this.uniqueKey} label`);
    // const input = document.querySelector(
    //   `.container-${this.uniqueKey} .md-input`
    // );

    //Container styles
    if (this.container) {
      this.container.style.width = this.width + "px";
      this.container.style.backgroundColor = this.backgroundColor;
    }

    //Label styles
    // if (label) {
    //   label.style.fontSize = this.labelFontSize;
    //   label.style.color = this.labelColor;
    //   label.style.fontWeight = this.labelFontWeight;
    // }

    //Input styles
    // if (input) {
    //   input.style.height = this.height;
    //   input.style.fontSize = this.fontSize;
    //   input.style.fontWeight = this.fontWeight;
    //   input.style.fontWeight = this.fontColor;
    // }

    this.setBackgroundOnDisabled();
  },
  methods: {
    handleEmit(value) {
      this.$emit("input", value);
    },
    setBackgroundOnDisabled() {
      this.container = document.querySelector(
        `.container-${this.uniqueKey} .md-theme-default`
      );
      const input = document.querySelector(
        `.container-${this.uniqueKey} .md-input`
      );

      const label = document.querySelector(
        `.container-${this.uniqueKey} label`
      );

      if (this.disabled) {
        // this.container.style.setProperty(
        //   "background-color",
        //   `#f2f2f280`,
        //   "important"
        // );
        input?.style.setProperty("opacity", "0.4", "important");
        label?.style.setProperty("opacity", "0.4", "important");
      } else {
        // this.container.style.setProperty(
        //   "background",
        //   this.backgroundColor,
        //   "important"
        // );
        input?.style.setProperty("opacity", "1", "important");
        label?.style.setProperty("opacity", "1", "important");
      }
    },
    setWidth() {
      this.container = document.querySelector(
        `.container-${this.uniqueKey} .md-theme-default`
      );
      this.container.style.width = this.width + "px";
    },
  },
  watch: {
    disabled() {
      this.setBackgroundOnDisabled();
    },
    width() {
      this.setWidth();
    },
  },
};
</script>

<style scoped>
.d-input-wrapper {
  display: flex;
  flex-direction: column;
  background: transparent;
  border: none;
  box-shadow: none;
  padding: 0;
  margin-bottom: 1rem !important;
}

.d-input-wrapper .p-float-label {
  width: 100%;
}

.d-input-wrapper :deep(.p-inputtext) {
  width: 100%;
  height: 55px;
  border-radius: 4px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  font-size: 14px;
  color: #0f172a;
  padding: 0 14px;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.d-input-wrapper :deep(.p-inputtext:enabled:focus) {
  outline: none;
  border-color: var(--primary-color, #4e7fff);
  box-shadow: 0 0 0 3px rgba(78, 127, 255, 0.12);
}

.d-input-wrapper :deep(.p-inputtext:enabled:hover) {
  border-color: #cbd5e1;
}

/* Label sits left-centered (placeholder position) */
.d-input-wrapper :deep(.p-float-label label) {
  position: absolute;
  top: 50%;
  left: 14px;
  transform: translateY(-50%);
  font-size: 14px;
  color: #64748b;
  margin: 0;
  pointer-events: none;
  transition: top 0.2s, font-size 0.2s, color 0.2s, transform 0.2s;
}

/* Label floats to top when focused or filled */
.d-input-wrapper :deep(.p-float-label .p-inputtext:focus ~ label),
.d-input-wrapper :deep(.p-float-label .p-inputwrapper-filled ~ label),
.d-input-wrapper :deep(.p-float-label .p-inputtext.p-filled ~ label) {
  top: 10px;
  transform: translateY(0);
  font-size: 11px;
  color: var(--primary-color, #4e7fff);
}

/* Shift text down when label is floating so they don't overlap */
.d-input-wrapper :deep(.p-float-label .p-inputtext:focus),
.d-input-wrapper :deep(.p-float-label .p-inputtext.p-filled) {
  padding-top: 18px;
  padding-bottom: 4px;
}

.d-input-wrapper :deep(.p-invalid) {
  border-color: #ef4444;
}

.md-error {
  font-size: 12px;
  color: #ef4444;
  margin-top: 4px;
}

.wizard-spinner {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
}

/* ── Dark mode ─────────────────────────────────────────────── */
[data-theme="dark"] .d-input-wrapper :deep(.p-inputtext) {
  background: #28364e;
  border-color: #3d5070;
  color: #e8edf5;
}

[data-theme="dark"] .d-input-wrapper :deep(.p-inputtext:enabled:hover) {
  border-color: #4e7fff;
}

[data-theme="dark"] .d-input-wrapper :deep(.p-inputtext:enabled:focus) {
  border-color: #4e7fff;
  box-shadow: 0 0 0 3px rgba(78, 127, 255, 0.15);
}

[data-theme="dark"] .d-input-wrapper :deep(.p-float-label label) {
  color: #6480a0;
}

[data-theme="dark"] .d-input-wrapper :deep(.p-float-label .p-inputtext:focus ~ label),
[data-theme="dark"] .d-input-wrapper :deep(.p-float-label .p-inputwrapper-filled ~ label),
[data-theme="dark"] .d-input-wrapper :deep(.p-float-label .p-inputtext.p-filled ~ label) {
  color: #4e7fff;
}
</style>